// @flow
import * as React from 'react';
import { rankWith, uiTypeIs } from '@jsonforms/core';

import useLayoutProps from 'platform/settings/form/renderers/util/useLayoutProps';
import PregenSeries from 'platform/settings/modules/orchestration/components/PregenSeries';

type Props = {};

const PregenSeriesLayout = (props: Props): React.Node => {
    const { uischema } = useLayoutProps(props);
    const translationPath = uischema.label.replace('.label', '');

    return <PregenSeries translationPath={translationPath} />;
};

export default PregenSeriesLayout;

export const pregenSeriesLayoutTester: any = rankWith(
    1,
    uiTypeIs('PregenSeriesLayout')
);
